import type { IProduct } from "@magnit/unit-catalog/src/unit-catalog.types";
import type { IPromoloaderSelectionsResponse } from "~/typings/api/promoloader";
import { urls } from "~/api/config";

export default () => {
  const storesStore = useStoresStore();
  const { transformItems } = promoApi();

  const requestSelections = (promoId: MaybeRef<string>) => {
    const url = computed(() => `${urls.promoloader.selections}/${storesStore.requestShopCode}/${toValue(promoId)}`);
    return useTransport<IPromoloaderSelectionsResponse, IProduct[]>(url, {
      transform: (data) => transformItems(data.data),
      lazy: import.meta.client,
    });
  };

  return {
    requestSelections,
  };
};
